"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrdersDataProvider = function () {
  function OrdersDataProvider(Orders) {
    "ngInject";

    (0, _classCallCheck3.default)(this, OrdersDataProvider);
    this.OrdersService = Orders;
  }

  (0, _createClass3.default)(OrdersDataProvider, [{
    key: "updateOrder",
    value: function updateOrder(data, type) {
      return this.OrdersService.updateOrder(data, type).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "getOrders",
    value: function getOrders(data) {
      return this.OrdersService.loadOrders(data).then(function (result) {
        return result;
      });
    }
  }, {
    key: "getOrder",
    value: function getOrder(id) {
      return this.OrdersService.getOrder(id).then(function (result) {
        return result;
      });
    }
  }, {
    key: "getItems",
    value: function getItems(id) {
      return this.OrdersService.getItems(id).then(function (result) {
        return result;
      });
    }
  }, {
    key: "getOrderStatusLogs",
    value: function getOrderStatusLogs(id) {
      return this.OrdersService.getOrderStatusLogs(id).then(function (result) {
        return result;
      });
    }
  }, {
    key: "updateOrderStatus",
    value: function updateOrderStatus(data) {
      return this.OrdersService.updateOrderStatus(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "resetOrderStatus",
    value: function resetOrderStatus(id) {
      return this.OrdersService.resetOrderStatus(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "updateInvoiceId",
    value: function updateInvoiceId(data) {
      return this.OrdersService.updateInvoiceId(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "getComments",
    value: function getComments(id) {
      return this.OrdersService.getComments(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "saveComments",
    value: function saveComments(data) {
      return this.OrdersService.saveComments(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "removeComment",
    value: function removeComment(id) {
      return this.OrdersService.removeComment(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "sendShippedMail",
    value: function sendShippedMail(id) {
      return this.OrdersService.sendShippedMail(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "sendInvoiceMail",
    value: function sendInvoiceMail(id) {
      return this.OrdersService.sendInvoiceMail(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "sendCollectionMail",
    value: function sendCollectionMail(id) {
      return this.OrdersService.sendCollectionMail(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "sendReceiptMail",
    value: function sendReceiptMail(id) {
      return this.OrdersService.sendReceiptMail(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "sendReviewMail",
    value: function sendReviewMail(id) {
      return this.OrdersService.sendReviewMail(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "sendPaperInvoiceMail",
    value: function sendPaperInvoiceMail(id) {
      return this.OrdersService.sendPaperInvoiceMail(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "sendReminderInvoiceMail",
    value: function sendReminderInvoiceMail(id) {
      return this.OrdersService.sendReminderInvoiceMail(id).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "saveShipmentResp",
    value: function saveShipmentResp(data) {
      return this.OrdersService.saveShipmentResp(data).then(function (resp) {
        return resp;
      });
    }
  }, {
    key: "tosvg",
    value: function tosvg(data) {
      return this.OrdersService.tosvg(data).then(function (resp) {
        return resp;
      });
    }
  }]);
  return OrdersDataProvider;
}();

// WEBPACK FOOTER //


exports.default = OrdersDataProvider;


/** WEBPACK FOOTER **
 ** ./client/app/modules/orders/services/order.dataprovider.service.js
 **/